module.exports = __webpack_public_path__ + "images/DMCABadge-bbe0036aae79f45e338532f7a309e91b.png";